import { createTheme } from "@mui/material/styles";


export const muiTheme = createTheme({
  spacing: 8,
  palette: {
    mode: "light",
    primary: { main: "#536DEC" },
    secondary: { main: "#2563EB" },
  },
  breakpoints: {
    values: { xs: 0, sm: 600, md: 900, lg: 1200, xl: 1536 },
  },
});